<template>
    <li :class="{active: (imgSrc == activeSrc)}">
        <a href="#//" @click="$emit('select-media-empty', imgSrc)">
            <div class="thumb">
                <img
                    :src="imgSrc"
                    :alt="`이미지(${index+1}) 입니다.`"
                >
                <span class="source-origin">사진출처: 한국문화원연합회</span>
            </div>
            <div class="data-wrap">
                <strong class="title">{{`이미지(${index+1})`}}</strong>
                <ul class="asset-data-meta">
                    <li>이야기자료</li>
                    <li class="bar">시청각물 > 사진</li>
                </ul>
            </div>
        </a>
    </li>
</template>

<script>
export default {
    props: {
        imgSrc: { type: String }, // 이미지 주소
        index: { type: Number|String }, // 이미지 인덱스
        activeSrc: { type: String }, // 크게 보여지고 있는 이미지
    },
}
</script>